import { render, staticRenderFns } from "./case-detail.vue?vue&type=template&id=43bec10e&scoped=true&"
import script from "./case-detail.vue?vue&type=script&lang=js&"
export * from "./case-detail.vue?vue&type=script&lang=js&"
import style0 from "./case-detail.vue?vue&type=style&index=0&id=43bec10e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bec10e",
  null
  
)

export default component.exports